import axios from "axios";

import { CLOUDINARY_URL } from "../../modules/common/constants/settings.consts";

const axiosClodinaryClient = axios.create();

/**
 * Performs a POST request to Cloudinary to upload an image.
 * @param {Object} params - The parameters for the request.
 * @returns {Promise} A promise that resolves to the Cloudinary API response.
 */
export const cloudinaryPost = (params) => {
  const { img } = params;

  var data = new FormData();

  data.append("upload_preset", "xphxxaqm");
  data.append("api_key", "675852613763464");
  data.append("file", img);
  data.append("timestamp", new Date());

  return axiosClodinaryClient.post(CLOUDINARY_URL, data);
};
